module.exports = {"endVisit":"Close visit","close":"Close","birthday":"Birthday","gender":"Gender","male":"Male","female":"Female","pesel":"PESEL","streetAddress":"Street address","city":"City","postCode":"Post code","patientHistory":"Patient history","attachmentsList":"List of attachments","patient":"Patient","attachments":"Attachments","invalidToken":"Invalid token \n Please login to the system again","businessName":"Business providing health services","signature":"Signature"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en.json
// module id = UpdR
// module chunks = 1